// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__3NKmC","illustration":"empty_state_illustration__6o30O","details":"empty_state_details__2-xRa"};